import React from 'react';
import { PageHero } from '../components/PageHero';
import { SectionStage } from '../components/SectionStage';
import { SnapshotForm } from '../components/SnapshotForm';
export function SnapshotPage() {
  return <>
      <PageHero eyebrow="Validation Snapshot" title="Start with proof." titleMuted="Not a procurement cycle." description="A Validation Snapshot is the first proof moment — focused, scoped, and delivered without a six-week sales motion." bg="none" data-id="element-1869" />

      <SectionStage fx="ripple" data-id="element-1870">
        <SnapshotForm data-id="element-1871" />
      </SectionStage>
    </>;
}